import {SET_APP_CONTEXT} from '../constants';
import {SetAppContextAction} from '../index';
import {Category} from './Category';

export function categoriesReducer(state: Category[] = [], action: SetAppContextAction): Category[] {
  switch (action.type) {
    case SET_APP_CONTEXT:
      return action.payload.categories;
    default:
      return state;
  }
}
